import { defineStore } from 'pinia';
import { store } from '/@/store';
export const useDialogStore = defineStore('alert', {
  state: () => ({
    isOpen: false,
    // message: '',
    // type: 'info', // 例如：info, success, warning, error
  }),
  actions: {
    openDialog() {
      console.log('openDialog...');
      this.isOpen = true;
    },
    closeDialog() {
      console.log('closeDialog...');
      this.isOpen = false;
    },
  },
});

export function useDialogStoreWithOut() {
  return useDialogStore(store);
}
